import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { formatDate } from "@/lib/format";
import { Button } from "@/components/ui/button";

export default function BlogArticle() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [nf, setNf] = useState(false);
  useEffect(() => { setP(null); setNf(false); api.get(`/blog/${slug}`).then((r) => setP(r.data)).catch(() => setNf(true)); }, [slug]);

  if (nf) return <div className="max-w-3xl mx-auto px-5 py-24 text-center"><h1 className="font-display text-3xl font-bold">Article not found</h1><Link to="/blog"><Button className="mt-6 rounded-full bg-[#C81D35] hover:bg-[#a5162b]">All articles</Button></Link></div>;
  if (!p) return <div className="max-w-3xl mx-auto px-5 py-14 animate-pulse"><div className="h-64 bg-muted rounded-2xl" /></div>;

  return (
    <article className="pb-16">
      {p.image && <div className="h-[380px] w-full overflow-hidden"><img src={p.image} alt={p.title} className="w-full h-full object-cover" /></div>}
      <div className="max-w-3xl mx-auto px-5 sm:px-8 -mt-16 relative">
        <div className="bg-white rounded-2xl border border-border shadow-sm p-8 sm:p-10">
          <nav className="text-sm text-muted-foreground mb-4"><Link to="/blog" className="hover:text-[#C81D35]">Blog</Link> / {p.category}</nav>
          <span className="text-xs font-semibold text-[#C81D35] uppercase tracking-wide">{p.category}</span>
          <h1 className="mt-2 font-display text-3xl sm:text-4xl font-bold text-[#111827] tracking-tight">{p.title}</h1>
          <p className="mt-3 text-sm text-muted-foreground">{p.author} · {formatDate(p.published_at)}</p>
          <div className="mt-8 prose prose-lg max-w-none text-[#111827]/80" dangerouslySetInnerHTML={{ __html: p.content || "" }} />
        </div>

        {p.related?.length > 0 && (
          <div className="mt-12">
            <h2 className="font-display text-2xl font-bold text-[#111827]">Related articles</h2>
            <div className="mt-4 grid sm:grid-cols-3 gap-5">
              {p.related.map((r) => (
                <Link key={r.id} to={`/blog/${r.slug}`} className="bg-white rounded-xl border border-border overflow-hidden hover:shadow-md transition-shadow">
                  {r.image && <div className="aspect-[16/10] overflow-hidden"><img src={r.image} alt={r.title} loading="lazy" className="w-full h-full object-cover" /></div>}
                  <div className="p-4"><h3 className="font-semibold text-sm text-[#111827] line-clamp-2">{r.title}</h3></div>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </article>
  );
}
